import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }
const _hoisted_9 = { class: "control-label col-sm-6" }
const _hoisted_10 = { class: "col-sm" }
const _hoisted_11 = { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }
const _hoisted_12 = { class: "control-label col-sm-6" }
const _hoisted_13 = { class: "col-sm" }
const _hoisted_14 = {
  key: 0,
  class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2"
}
const _hoisted_15 = { class: "control-label col-sm-6" }
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }
const _hoisted_18 = { class: "control-label col-sm-6" }
const _hoisted_19 = { class: "col-sm crm:text-right" }
const _hoisted_20 = { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }
const _hoisted_21 = { class: "control-label col-sm-6" }
const _hoisted_22 = { class: "col-sm" }
const _hoisted_23 = {
  key: 0,
  class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2"
}
const _hoisted_24 = { class: "control-label col-sm-6" }
const _hoisted_25 = { class: "col-sm" }
const _hoisted_26 = { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }
const _hoisted_27 = { class: "control-label col-sm-6" }
const _hoisted_28 = { class: "col-sm" }
const _hoisted_29 = { class: "row crm:items-center crm:my-6" }
const _hoisted_30 = { class: "control-label col-sm-6" }
const _hoisted_31 = { class: "col-sm" }
const _hoisted_32 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_33 = { class: "control-label col-sm-6" }
const _hoisted_34 = { class: "col-sm" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_37 = { class: "control-label col-sm-6" }
const _hoisted_38 = { class: "col-sm" }
const _hoisted_39 = { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }
const _hoisted_40 = { class: "control-label col-sm-6" }
const _hoisted_41 = { class: "col-sm" }
const _hoisted_42 = { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }
const _hoisted_43 = { class: "control-label col-sm-6" }
const _hoisted_44 = { class: "col-sm" }
const _hoisted_45 = { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }
const _hoisted_46 = { class: "control-label col-sm-6" }
const _hoisted_47 = { class: "col-sm" }
const _hoisted_48 = {
  key: 0,
  class: "row crm:items-center crm:my-6"
}
const _hoisted_49 = { class: "control-label col-sm-6" }
const _hoisted_50 = { class: "col-sm" }
const _hoisted_51 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_52 = { class: "control-label col-sm-6" }
const _hoisted_53 = { class: "col-sm" }

import { ref, watch ,reactive, inject } from 'vue'
import Alertify from 'alertifyjs'
import { usePreventivo } from '../../composable/usePreventivo'
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";
import BaseAccordion from 'fallco-frontend-framework/src/vue/components/layout/BaseAccordion.vue'
import BaseChoice from 'fallco-frontend-framework/src/vue/components/layout/BaseChoice.vue'
import BaseChoiceItem from 'fallco-frontend-framework/src/vue/components/layout/BaseChoiceItem.vue'
import FormImmobiliareHelper from "./../../pages/preventivi/json/immobiliare/helper.json";
import DettaglioPreventivoHelper from "./../../pages/preventivi/json/dettagliopreventivo/helper.json";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";

export default {
  __name: 'FormImmobiliareOperazioniIpoteche',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo','infoCompilazione'],
  setup(__props, { emit: __emit }) {

const props = __props
const {
  categoriaImmobiliare
} = usePreventivo()
let validazione;
const validazioneEquoCompenso = ref();
const accordionArea = ref([])
const { regimeFiscale } = inject('regimeFiscale')
const rowDefaultVolontarie = reactive({
  content_cancellazione: false,
  content_cancellazione_giudiziali:false,
  content_pignoramento:false,
  content_erogazioni:false,
  content_frazionamento:false,
  content_rinegoziazione:false,
  content_svincoli:false,
  content_riduzione:false
  })
const rowDefaultGiudiziali = reactive({
  content_pignoramento: false,
  content_cancellazione_giudiziali: false,
})

function tipoSvincoloSelezionato (event) {
  if (event.target.value == 'svincolo_con_corrispettivo_e_riduzione') {
    validazione.valore_svincolo_corrispettivo_riduzione.required = true
  } else {
    validazione.valore_svincolo_corrispettivo_riduzione.required = false
  }
}

switch (props.formName) {
  case 'operazioniIpotecheVolontarie':
    validazione = categoriaImmobiliare['sottocategoriaOperazioniIpoteche']['operazioniIpotecheVolontarie']
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaOperazioniIpoteche']['operazioniIpotecheVolontarie'];
    break
  case 'operazioniIpotecheGiudizialiPignoramenti':
    validazione = categoriaImmobiliare['sottocategoriaOperazioniIpoteche']['operazioniIpotecheGiudizialiPignoramenti']
    validazioneEquoCompenso.value = categoriaImmobiliare['sottocategoriaOperazioniIpoteche']['operazioniIpotecheGiudizialiPignoramenti'];
    break
}
const emits = __emit;
const testoInfoCompilazione = ref([]);
if (validazione) {
  validazione.tipo_preventivo.value = 'immobiliare/operazioni_su_ipoteche/' + props.tipoPreventivo.data.url
}
watch(validazione, (newValue, oldValue) => {
  emits('changeDatiPreventivo')
}, { deep: true });
function checkActiveTab (data) {

  if (data.includes('content_cancellazione')) {
    rowDefaultVolontarie.content_cancellazione = true;
    validazione.valore_ipoteca.required = true
    validazione.tab_cancellazione.value = 1
  } else {
    if (validazione.tab_cancellazione.value == 1) {
      rowDefaultVolontarie.content_cancellazione = false;
      validazione.valore_ipoteca.required = false
      if (validazione.valore_ipoteca.value != '' && validazione.valore_ipoteca.value != '0') {
        Alertify.confirm('Attenzione: La chiusura della sezione <b>Cancellazione</b> comporter&agrave; la perdita dei dati inseriti, si intente proseguire?',
            () => {
              validazione.valore_ipoteca.value = ''
              validazione.tab_cancellazione.value = 0
              delete data.content_cancellazione

            },
            () => {
              rowDefaultVolontarie.content_cancellazione = true;
              validazione.tab_cancellazione.value = 1
            }
        )
      } else {
        validazione.tab_cancellazione.value = 0
      }
    }
  }

  if (data.includes('content_riduzione')) {
    rowDefaultVolontarie.content_riduzione = true;
    validazione.tab_riduzione.value = 1
    validazione.valore_riduzione_ipoteca_capitale.required = true
  } else {
    if (validazione.tab_riduzione.value == 1) {
      rowDefaultVolontarie.content_riduzione = false;
      validazione.valore_riduzione_ipoteca_capitale.required = false
      if (validazione.valore_riduzione_ipoteca_capitale.value != '' && validazione.valore_riduzione_ipoteca_capitale.value != '0') {
        Alertify.confirm('Attenzione: La chiusura della sezione <b>Riduzione</b> comporter&agrave; la perdita dei dati inseriti, si intente proseguire?',
            () => {
              validazione.tab_riduzione.value = 0
              validazione.valore_riduzione_ipoteca_capitale.value = ''
              delete data.content_riduzione
            },
            () => {
              rowDefaultVolontarie.content_riduzione = true;
              validazione.tab_riduzione.value = 1
            }
        )
      } else {
        validazione.tab_riduzione.value = 0
      }
    }
  }

  if (data.includes('content_erogazioni')) {
    validazione.tab_erogazioni.value = 1
    rowDefaultVolontarie.content_erogazioni = true;
  } else {
    if (validazione.tab_erogazioni.value == 1) {
      rowDefaultVolontarie.content_erogazioni = false
      if (validazione.tipo_erogazione.value != '') {
        Alertify.confirm('Attenzione: La chiusura della sezione <b>Erogazioni</b> comporter&agrave; la perdita dei dati inseriti, si intente proseguire?',
            () => {
              validazione.tab_erogazioni.value = 0
              validazione.tipo_erogazione.value = ''
              delete data.content_erogazioni
            },
            () => {
              rowDefaultVolontarie.content_erogazioni = true;
              validazione.tab_erogazioni.value = 1
            }
        )
      } else {
        validazione.tab_erogazioni.value = 0
      }
    }
  }

  if (data.includes('content_frazionamento')) {
    validazione.tab_frazionamento.value = 1
    rowDefaultVolontarie.content_frazionamento = true;
  } else {
    if (validazione.tab_frazionamento.value == 1) {
      rowDefaultVolontarie.content_frazionamento = false;
      if (validazione.valore_frazionamento.value != '' && validazione.valore_frazionamento.value != '0') {
        Alertify.confirm('Attenzione: La chiusura della sezione <b>Frazionamento</b> comporter&agrave; la perdita dei dati inseriti, si intente proseguire?',
            () => {
              validazione.tab_frazionamento.value = 0
              validazione.valore_frazionamento.value = ''
              delete data.content_frazionamento
            },
            () => {
              validazione.tab_frazionamento.value = 1
              rowDefaultVolontarie.content_frazionamento = true;
            })
      } else {
        validazione.tab_frazionamento.value = 0
      }
    }
  }

  if (data.includes('content_rinegoziazione')) {
    validazione.tab_rinegoziazione.value = 1
    rowDefaultVolontarie.content_rinegoziazione = true;
  } else {
    if (validazione.tab_rinegoziazione.value == 1) {
      if (validazione.attivare_rinegoziazione_atto.value != '') {
        rowDefaultVolontarie.content_rinegoziazione = false
        Alertify.confirm('Attenzione: La chiusura della sezione <b>Rinegoziazione</b> comporter&agrave; la perdita dei dati inseriti, si intente proseguire?',
            () => {
              validazione.tab_rinegoziazione.value = 0
              validazione.attivare_rinegoziazione_atto.value = ''
              delete data.content_rinegoziazione
            },
            () => {
              rowDefaultVolontarie.content_rinegoziazione = true
              validazione.tab_rinegoziazione.value = 1
            }
        )
      } else {
        validazione.tab_rinegoziazione.value = 0
      }
    }
  }

  if (data.includes('content_svincoli')) {
    validazione.tab_svincoli.value = 1;
    rowDefaultVolontarie.content_svincoli = true
    validazione.tipo_svincolo.required = true
  } else {
    if (validazione.tab_svincoli.value == 1) {
      rowDefaultVolontarie.content_svincoli = false
      if (validazione.tipo_svincolo.value != '' && validazione.tipo_svincolo.value != '0') {
        Alertify.confirm('Attenzione: La chiusura della sezione <b>Svincoli</b> comporter&agrave; la perdita dei dati inseriti, si intente proseguire?',
            () => {
              validazione.valore_svincolo_corrispettivo_riduzione.required = false
              validazione.tab_svincoli.value = 0
              validazione.tipo_svincolo.value = ''
              validazione.valore_svincolo_corrispettivo_riduzione.value = ''
              delete data.content_svincoli
            },
            () => {
              validazione.tab_svincoli.value = 1
              rowDefaultVolontarie.content_svincoli = true
            }
        )
      } else {
        validazione.tab_svincoli.value = 0;
      }
    }
  }

}
function checkActiveTabGiudiziali(data){
  if (data.includes('content_cancellazione_giudiziali')) {
    validazione.valore_ipoteca.required = true
    validazione.tab_cancellazione_giudiziali.value = 1
    rowDefaultGiudiziali.content_cancellazione_giudiziali = true;
  } else {
    if(validazione.tab_cancellazione_giudiziali.value == 1){
      rowDefaultGiudiziali.content_cancellazione_giudiziali = false;
      validazione.valore_ipoteca.required = false;
      if (validazione.valore_ipoteca.value != '' && validazione.valore_ipoteca.value != '0') {
        Alertify.confirm('Attenzione: La chiusura della sezione <b>Cancellazione</b> comporter&agrave; la perdita dei dati inseriti, si intente proseguire?',
            () => {
              validazione.valore_ipoteca.value = ''
              validazione.tab_cancellazione_giudiziali.value = 0
              delete data.content_cancellazione_giudiziali
            },
            () => {
              rowDefaultVolontarie.content_cancellazione = true
              validazione.tab_cancellazione_giudiziali.value = 1
              rowDefaultGiudiziali.content_cancellazione_giudiziali = true;
            }
        )
      } else {
        validazione.tab_cancellazione_giudiziali.value = 0
      }
    }
  }

  if (data.includes('content_pignoramento')) {
    validazione.numero_pignoramenti.value = 1
    validazione.valore_pignoramento.required = true
    validazione.tab_pignoramento.value = 1
    rowDefaultGiudiziali.content_pignoramento = true;
  } else {
    if(validazione.tab_pignoramento.value == 1){
      rowDefaultGiudiziali.content_pignoramento = false;
      validazione.valore_ipoteca.required = false;
      if (validazione.valore_pignoramento.value != '' && validazione.valore_pignoramento.value != '0') {
        Alertify.confirm('Attenzione: La chiusura della sezione <b>Cancellazione</b> comporter&agrave; la perdita dei dati inseriti, si intente proseguire?',
            () => {
              validazione.numero_pignoramenti.value = ''
              validazione.valore_pignoramento.value = ''
              validazione.tab_pignoramento.value = 0
              delete data.content_pignoramento
            },
            () => {
              rowDefaultGiudiziali.content_pignoramento = true
              validazione.tab_pignoramento.value = 1

            }
        )
      } else {
        validazione.tab_pignoramento.value = 0
      }
    }
  }

}
function tipoOperazione(event){
  if(event.target.value == 'con_atto_notarile'){
    validazione.forma_del_titolo.value = '';
    validazione.forma_del_titolo.required = true;
  } else {
    validazione.forma_del_titolo.value = '';
    validazione.forma_del_titolo.required = false;
  }
}
let indexHelperClosing = {
  calcolo:FormImmobiliareHelper.sottocategoriaOperazioniIpoteche[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}
testoInfoCompilazione.value =  FormImmobiliareHelper.sottocategoriaOperazioniIpoteche[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'operazioniIpotecheVolontarie')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).derivante_da.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.derivante_da.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_select, {
                name: "derivante_da",
                options: [{name: 'Mutuo Fondiario', value: 'mutuo_fondiario'},
            {name: 'Mutuo Ipotecario', value: 'mutuo_ipotecario'}],
                isSelected: _unref(validazione).derivante_da.value != '',
                disabled: __props.readonly,
                validateTo: _unref(validazione).derivante_da,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).derivante_da) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "disabled", "validateTo"])
            ])
          ]),
          _createVNode(BaseChoice, {
            isMultiple: true,
            "onGet:activeChoice": checkActiveTab
          }, {
            default: _withCtx(() => [
              _createVNode(BaseChoiceItem, {
                id: "content_cancellazione",
                "custom-classes": {container: {base: 'crm:flex-col crm:bg-gray-100'}}
              }, {
                reference: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("div", { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }, [
                    _createElementVNode("span", { class: "crm:font-bold" }, "Cancellazione")
                  ], -1 /* CACHED */)
                ]))]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
                      _createTextVNode(_toDisplayString(_unref(validazione).valore_ipoteca.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_ipoteca.ref]
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_base_input_text, {
                        id: "valore_ipoteca",
                        name: "valore_ipoteca",
                        class: "placeholder-right",
                        placeholder: "0,00",
                        disabled: rowDefaultVolontarie.content_cancellazione == false,
                        "validate-to": _unref(validazione).valore_ipoteca,
                        "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).valore_ipoteca) = $event))
                      }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(BaseChoiceItem, {
                id: "content_erogazioni",
                "custom-classes": {container: {base: 'crm:flex-col crm:bg-gray-100'}}
              }, {
                reference: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("div", { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }, [
                    _createElementVNode("span", { class: "crm:font-bold" }, "Erogazione")
                  ], -1 /* CACHED */)
                ]))]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_unref(validazione).tipo_erogazione.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_erogazione.ref]
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_base_select, {
                        name: "tipo_erogazione",
                        options: [{name: 'Quietanza a saldo', value: 'quietanza_a_saldo'},
                  {name: 'Erogazione parziale', value: 'erogazione_parziale'}],
                        isSelected: _unref(validazione).tipo_erogazione.value != '',
                        state: rowDefaultVolontarie.content_erogazioni == false ?'disable':'',
                        validateTo: _unref(validazione).tipo_erogazione,
                        "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).tipo_erogazione) = $event))
                      }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(BaseChoiceItem, {
                id: "content_frazionamento",
                "custom-classes": {container: {base: 'crm:flex-col crm:bg-gray-100'}}
              }, {
                reference: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("div", { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }, [
                    _createElementVNode("span", { class: "crm:font-bold" }, "Frazionamento del mutuo o dell'ipoteca")
                  ], -1 /* CACHED */)
                ]))]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
                      _createTextVNode(_toDisplayString(_unref(validazione).tipo_frazionamento.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_frazionamento.ref]
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_base_select, {
                        name: "tipo_frazionamento",
                        options: [
                  {name: 'Contestuale ad erogazione e/o quietanza', value: 'contestuale_erogazione_quietanza'},
                  {name: 'Solo frazionamento', value: 'solo_frazionamento'}
                  ],
                        isSelected: _unref(validazione).tipo_frazionamento.value != '',
                        state: rowDefaultVolontarie.content_frazionamento == false ?'disable':'',
                        validateTo: _unref(validazione).tipo_frazionamento,
                        "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).tipo_frazionamento) = $event))
                      }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                    ])
                  ]),
                  (_unref(validazione).tipo_frazionamento.value == 'solo_frazionamento')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_15, [
                          _createTextVNode(_toDisplayString(_unref(validazione).valore_frazionamento.label), 1 /* TEXT */)
                        ])), [
                          [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_frazionamento.ref]
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_base_input_text, {
                            id: "valore_frazionamento",
                            name: "valore_frazionamento",
                            class: "placeholder-right",
                            placeholder: "0,00",
                            disabled: rowDefaultVolontarie.content_frazionamento == false,
                            "validate-to": _unref(validazione).valore_frazionamento,
                            "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).valore_frazionamento) = $event))
                          }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(BaseChoiceItem, {
                id: "content_rinegoziazione",
                "custom-classes": {container: {base: 'crm:flex-col crm:bg-gray-100'}}
              }, {
                reference: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createElementVNode("div", { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }, [
                    _createElementVNode("span", { class: "crm:font-bold" }, "Rinegoziazione")
                  ], -1 /* CACHED */)
                ]))]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_18, [
                      _createTextVNode(_toDisplayString(_unref(validazione).attivare_rinegoziazione_atto.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.attivare_rinegoziazione_atto.ref]
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_base_input_checkbox, {
                        class: _normalizeClass(props.disabilita ? 'crm:opacity-20 crm:pointer-events-none':''),
                        name: "attivare_rinegoziazione_atto",
                        label: "Si, attiva",
                        disabled: rowDefaultVolontarie.content_rinegoziazione == false,
                        "validate-to": _unref(validazione).attivare_rinegoziazione_atto,
                        "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).attivare_rinegoziazione_atto) = $event))
                      }, null, 8 /* PROPS */, ["class", "disabled", "validate-to"])
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(BaseChoiceItem, {
                id: "content_svincoli",
                "custom-classes": {container: {base: 'crm:flex-col crm:bg-gray-100'}}
              }, {
                reference: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createElementVNode("div", { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }, [
                    _createElementVNode("span", { class: "crm:font-bold" }, "Svincolo ipotecario")
                  ], -1 /* CACHED */)
                ]))]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_21, [
                      _createTextVNode(_toDisplayString(_unref(validazione).tipo_svincolo.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_svincolo.ref]
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_base_select, {
                        name: "tipo_svincolo",
                        options: [
                    {name: 'Svincolo senza corrispettivo', value: 'svincolo_senza_corrispettivo_senza_riduzione'},
                    {name: 'Svincolo con corrispettivo', value: 'svincolo_con_corrispettivo_e_riduzione'}
                    ],
                        isSelected: _unref(validazione).tipo_svincolo.value != '',
                        state: rowDefaultVolontarie.content_svincoli == false ?'disable':'',
                        onChange: _cache[6] || (_cache[6] = $event => (!props.disabilita ? tipoSvincoloSelezionato($event) : '')),
                        validateTo: _unref(validazione).tipo_svincolo,
                        "onUpdate:validateTo": _cache[7] || (_cache[7] = $event => ((_unref(validazione).tipo_svincolo) = $event))
                      }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
                    ])
                  ]),
                  (_unref(validazione).tipo_svincolo.value == 'svincolo_con_corrispettivo_e_riduzione')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_24, [
                          _createTextVNode(_toDisplayString(_unref(validazione).valore_svincolo_corrispettivo_riduzione.label), 1 /* TEXT */)
                        ])), [
                          [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_svincolo_corrispettivo_riduzione.ref]
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_base_input_text, {
                            id: "valore_svincolo_corrispettivo_riduzione",
                            name: "valore_svincolo_corrispettivo_riduzione",
                            class: "placeholder-right",
                            placeholder: "0,00",
                            disabled: rowDefaultVolontarie.content_svincoli == false,
                            "validate-to": _unref(validazione).valore_svincolo_corrispettivo_riduzione,
                            "onUpdate:validateTo": _cache[8] || (_cache[8] = $event => ((_unref(validazione).valore_svincolo_corrispettivo_riduzione) = $event))
                          }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(BaseChoiceItem, {
                id: "content_riduzione",
                "custom-classes": {container: {base: 'crm:flex-col crm:bg-gray-100'}}
              }, {
                reference: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("div", { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }, [
                    _createElementVNode("span", { class: "crm:font-bold" }, "Riduzione")
                  ], -1 /* CACHED */)
                ]))]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_26, [
                    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_27, [
                      _createTextVNode(_toDisplayString(_unref(validazione).valore_riduzione_ipoteca_capitale.label), 1 /* TEXT */)
                    ])), [
                      [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_riduzione_ipoteca_capitale.ref]
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_base_input_text, {
                        id: "valore_riduzione_ipoteca_capitale",
                        name: "valore_riduzione_ipoteca_capitale",
                        class: "placeholder-right",
                        placeholder: "0,00",
                        disabled: rowDefaultVolontarie.content_riduzione == false,
                        "validate-to": _unref(validazione).valore_riduzione_ipoteca_capitale,
                        "onUpdate:validateTo": _cache[9] || (_cache[9] = $event => ((_unref(validazione).valore_riduzione_ipoteca_capitale) = $event))
                      }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", _hoisted_29, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_30, [
              _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_base_select, {
                name: "forma_del_titolo",
                options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                isSelected: _unref(validazione).forma_del_titolo.value != '',
                validateTo: _unref(validazione).forma_del_titolo,
                "onUpdate:validateTo": _cache[10] || (_cache[10] = $event => ((_unref(validazione).forma_del_titolo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "validateTo"])
            ])
          ]),
          (_unref(regimeFiscale) == 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_33, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[11] || (_cache[11] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(AliquoteContributiRepertoriali, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly,
            "filter-options-d": true
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'operazioniIpotecheGiudizialiPignoramenti')
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_37, [
                _createTextVNode(_toDisplayString(_unref(validazione).tipo_operazione.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo_operazione.ref]
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_base_select, {
                  name: "tipo_operazione",
                  options: [{name: 'Con atto notarile', value: 'con_atto_notarile'},
            {name: 'Solo adempimenti', value: 'solo_adempimenti'}],
                  isSelected: _unref(validazione).tipo_operazione.value != '',
                  onChange: _cache[12] || (_cache[12] = $event => (tipoOperazione($event))),
                  validateTo: _unref(validazione).tipo_operazione,
                  "onUpdate:validateTo": _cache[13] || (_cache[13] = $event => ((_unref(validazione).tipo_operazione) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "validateTo"])
              ])
            ]),
            _createVNode(BaseChoice, {
              isMultiple: true,
              "onGet:activeChoice": checkActiveTabGiudiziali
            }, {
              default: _withCtx(() => [
                _createVNode(BaseChoiceItem, {
                  id: "content_pignoramento",
                  "custom-classes": {container: {base: 'crm:flex-col crm:bg-gray-100'}}
                }, {
                  reference: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("div", { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }, [
                      _createElementVNode("span", { class: "crm:font-bold" }, "Pignoramento")
                    ], -1 /* CACHED */)
                  ]))]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_40, [
                        _createTextVNode(_toDisplayString(_unref(validazione).valore_pignoramento.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_pignoramento.ref]
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_base_input_text, {
                          id: "valore_pignoramento",
                          name: "valore_pignoramento",
                          class: "placeholder-right",
                          placeholder: "0,00",
                          disabled: rowDefaultGiudiziali.content_pignoramento == false,
                          "validate-to": _unref(validazione).valore_pignoramento,
                          "onUpdate:validateTo": _cache[14] || (_cache[14] = $event => ((_unref(validazione).valore_pignoramento) = $event))
                        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_43, [
                        _createTextVNode(_toDisplayString(_unref(validazione).numero_pignoramenti.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_pignoramenti.ref]
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_base_input_text, {
                          id: "numero_pignoramenti",
                          name: "numero_pignoramenti",
                          class: "placeholder-right crm:text-right",
                          placeholder: "1",
                          disabled: rowDefaultGiudiziali.content_pignoramento == false,
                          "validate-to": _unref(validazione).numero_pignoramenti,
                          "onUpdate:validateTo": _cache[15] || (_cache[15] = $event => ((_unref(validazione).numero_pignoramenti) = $event))
                        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                      ])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(BaseChoiceItem, {
                  id: "content_cancellazione_giudiziali",
                  "custom-classes": {container:{base: 'crm:flex-col crm:bg-gray-100'}}
                }, {
                  reference: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createElementVNode("div", { class: "crm:flex crm:items-center crm:justify-between crm:w-full crm:p-2" }, [
                      _createElementVNode("span", { class: "crm:font-bold" }, "Cancellazione")
                    ], -1 /* CACHED */)
                  ]))]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_45, [
                      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_46, [
                        _createTextVNode(_toDisplayString(_unref(validazione).valore_ipoteca.label), 1 /* TEXT */)
                      ])), [
                        [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore_ipoteca.ref]
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_base_input_text, {
                          id: "valore_ipoteca",
                          name: "valore_ipoteca",
                          class: "placeholder-right",
                          placeholder: "0,00",
                          disabled: rowDefaultGiudiziali.content_cancellazione_giudiziali == false,
                          "validate-to": _unref(validazione).valore_ipoteca,
                          "onUpdate:validateTo": _cache[16] || (_cache[16] = $event => ((_unref(validazione).valore_ipoteca) = $event))
                        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                      ])
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            (_unref(validazione).tipo_operazione.value == 'con_atto_notarile')
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_49, [
                    _createTextVNode(_toDisplayString(_unref(validazione).forma_del_titolo.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.forma_del_titolo.ref]
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_base_select, {
                      name: "forma_del_titolo",
                      options: [{name: 'Pubblico', value: 'pubblico'},{name: 'Privato', value: 'privato'}],
                      isSelected: _unref(validazione).forma_del_titolo.value != '',
                      validateTo: _unref(validazione).forma_del_titolo,
                      "onUpdate:validateTo": _cache[17] || (_cache[17] = $event => ((_unref(validazione).forma_del_titolo) = $event))
                    }, null, 8 /* PROPS */, ["isSelected", "validateTo"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (_unref(regimeFiscale) == 'ordinario')
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_52, [
                    _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_base_input_checkbox, {
                      class: _normalizeClass(props.disabilita ? 'crm:opacity-20  crm:pointer-events-none':''),
                      name: "ritenuta_acconto",
                      label: "Si, applicabile",
                      "validate-to": _unref(validazione).ritenuta_acconto,
                      "onUpdate:validateTo": _cache[18] || (_cache[18] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                    }, null, 8 /* PROPS */, ["class", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "",
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly,
              "filter-options-d": true
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}